/** @internal */
export const EMPTY_OBJECT: Record<string, unknown> = Object.freeze({})

/** @internal */
export const EMPTY_ARRAY: never[] = Object.freeze([]) as never[]
